<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Void E-Coupon</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Void Section -->
    <form @submit.prevent="voidEcoupon">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-2">E-Coupon Code*</label>
                <div class="col-md-3 pl-0">
                  <input
                    type="text"
                    v-model="code"
                    class="form-control"
                    maxlength="50"
                    required
                  />
                </div>
              </div>

              <div class="form-group row align-items-center">
                <label class="col-md-2">Void Remarks*</label>
                <div class="col-md-6 pl-0">
                  <textarea class="form-control" rows="6" v-model="remarks" required></textarea>
                </div>
              </div>

              <div class="form-group row align-items-center">
                <label class="col-md-2">&nbsp;</label>
                <div class="col-md-4 pl-0">
                  <button class="btn btn-primary" :disabled="this.code.length == 0 || this.remarks.length == 0">Void</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- /Void Section -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      code: "",
      remarks: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  methods: {
    voidEcoupon() {
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to void the code?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.voidBatchEcoupon({ code: this.code, void_remarks: this.remarks }, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.code = "";
              this.remarks = "";
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Merchant/VoidEcoupon.vue